// Gets the half cilinder heigth with its current capacity.
export const getCylinderHeight = (arg: number) => {
  return arg * 0.6;
};
